// // DemoSessionForm.js
// import React, { useState } from "react";
// import "../demoform.css";

// export default function DemoSessionForm() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     domain: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Submitted", formData);
//     alert("Form submitted successfully!");
//     setFormData({ fullName: "", email: "", phone: "", domain: "" });
//   };

//   return (
//     <div className="demo-form-wrapper">
//       <h2>Fill The Form</h2>
//       <form className="demo-form" onSubmit={handleSubmit}>
//         <label>
//           <span>Full Name</span>
//           <input
//             type="text"
//             name="fullName"
//             placeholder="Your answer"
//             value={formData.fullName}
//             onChange={handleChange}
//             required
//           />
//         </label>

//         <label>
//           <span>Email Address</span>
//           <input
//             type="email"
//             name="email"
//             placeholder="Your answer"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//         </label>

//         <label>
//           <span>Phone Number</span>
//           <input
//             type="tel"
//             name="phone"
//             placeholder="Your answer"
//             value={formData.phone}
//             onChange={handleChange}
//             required
//           />
//         </label>

//         <label>
//           <span>Choose Domain</span>
//           <select
//             name="domain"
//             value={formData.domain}
//             onChange={handleChange}
//             required
//           >
//                   <option value="">Select a Domain...</option>
//           <option>Android App Development</option>
//           <option>Artifical Inteligence</option>
//           <option>AR/VR</option>
//           <option>Autocad</option>
//           <option>Bio Informatics</option>
//           <option>Business Analytics</option>
//           <option>C, C++ With DSA</option>
//           <option>Car Design</option>
//           <option>Cloud Computing</option>
//           <option>Cyber Security</option>
//           <option>Data Science</option>
//           <option>Digital Markeing & Marketing</option>
//           <option>Embedded Systems</option>
//           <option>Finance</option>
//           <option>Full Stack Web Development</option>
//           <option>Generative AI</option>
//           <option>Genetic Engineering</option>
//           <option>Graphic Design</option>
//           <option>Human Resources</option>
//           <option>(HEV) Hybrid Electric Vehicle</option>
//           <option>IC Engine</option>
//           <option>Internet Of Things (IOT)</option>
//           <option>Java</option>
//           <option>Machine Learning With Python</option>
//           <option>Mern Stack</option>
//           <option>Nanoscience Nanotechnology</option>
//           <option>Psychology</option>
//           <option>Python</option>
//           <option>Regulatory Affairs (In Pharma & Healthcare)</option>
//           <option>Robotics</option>
//           <option>Stock Market</option>
//           <option>Supply Chain Management</option>
//           <option>UI/UX Design</option>
//           <option>VlSI Design</option>
//           <option>Web Development</option>
//           </select>
//         </label>

//         <div className="form-buttons">
//           <button type="submit" className="btn-submit">
//             Submit
//           </button>
//           {/* <button
//             type="button"
//             className="btn-close"
//             onClick={() => setFormData({ fullName: "", email: "", phone: "", domain: "" })}
//           >
//             Close
//           </button> */}
//         </div>
//       </form>
//     </div>
//   );
// }


// DemoSessionForm.js
import React, { useState } from "react";
import "../demoform.css";

export default function DemoSessionForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    domain: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await fetch("https://script.google.com/macros/s/AKfycbxWZyMaQp0TDfOk5Fbml991q8vkSEC3CaIjN6MYlorH4oB9DtL8W8ZS3CYAkq3SZTeP/exec", {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      alert("Form submitted successfully!");

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        domain: "",
      });

    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit! Try again.");
    }
  };

  return (
    <div className="demo-form-wrapper">
      <h2>Fill The Form</h2>
      <form className="demo-form" onSubmit={handleSubmit}>
        <label>
          <span>Full Name</span>
          <input
            type="text"
            name="fullName"
            placeholder="Your answer"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span>Email Address</span>
          <input
            type="email"
            name="email"
            placeholder="Your answer"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span>Phone Number</span>
          <input
            type="tel"
            name="phone"
            placeholder="Your answer"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span>Choose Domain</span>
          <select
            name="domain"
            value={formData.domain}
            onChange={handleChange}
            required
          >
            <option value="">Select a Domain...</option>
            <option>Android App Development</option>
            <option>Artifical Inteligence</option>
            <option>AR/VR</option>
            <option>Autocad</option>
            <option>Bio Informatics</option>
            <option>Business Analytics</option>
            <option>C, C++ With DSA</option>
            <option>Car Design</option>
            <option>Cloud Computing</option>
            <option>Cyber Security</option>
            <option>Data Science</option>
            <option>Digital Markeing & Marketing</option>
            <option>Embedded Systems</option>
            <option>Finance</option>
            <option>Full Stack Web Development</option>
            <option>Generative AI</option>
            <option>Genetic Engineering</option>
            <option>Graphic Design</option>
            <option>Human Resources</option>
            <option>(HEV) Hybrid Electric Vehicle</option>
            <option>IC Engine</option>
            <option>Internet Of Things (IOT)</option>
            <option>Java</option>
            <option>Machine Learning With Python</option>
            <option>Mern Stack</option>
            <option>Nanoscience Nanotechnology</option>
            <option>Psychology</option>
            <option>Python</option>
            <option>Regulatory Affairs (In Pharma & Healthcare)</option>
            <option>Robotics</option>
            <option>Stock Market</option>
            <option>Supply Chain Management</option>
            <option>UI/UX Design</option>
            <option>VlSI Design</option>
            <option>Web Development</option>
          </select>
        </label>

        <div className="form-buttons">
          <button type="submit" className="btn-submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
